(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  class AccountDashboard {
    constructor() {
      this.tabs = document.querySelectorAll('.account-dashboard__tab');
      this.panels = document.querySelectorAll('.account-dashboard__panel');
      this.tabLinks = document.querySelectorAll('[data-tab-link]');
      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
      });

      this.tabLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchTab(link.dataset.tabLink);
        });
      });

      const hash = window.location.hash.replace('#', '');
      if (hash && document.getElementById('tab-' + hash)) {
        this.switchTab(hash);
      }

      this.initForms();
      this.initFeedbackModal();
    }

    switchTab(tabName) {
      this.tabs.forEach(tab => {
        const isActive = tab.dataset.tab === tabName;
        tab.classList.toggle('account-dashboard__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach(panel => {
        const isActive = panel.id === 'tab-' + tabName;
        panel.classList.toggle('account-dashboard__panel--active', isActive);
        panel.hidden = !isActive;
      });

      history.replaceState(null, null, '#' + tabName);

      if (window.innerWidth < 750) {
        document.querySelector('.account-dashboard__tabs').scrollIntoView({ behavior: 'smooth' });
      }
    }

    initForms() {
      const forms = [
        { id: 'auto-schedule-form', type: 'Auto-Schedule' },
        { id: 'adjust-schedule-form', type: 'Reschedule Request' },
        { id: 'contract-change-form', type: 'Contract Change Request' },
        { id: 'preferences-form', type: 'Service Preferences Update' }
      ];

      forms.forEach(({ id, type }) => {
        const form = document.getElementById(id);
        if (form) {
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleFormSubmit(form, type);
          });
        }
      });
    }

    handleFormSubmit(form, type) {
      const formData = new FormData(form);
      const data = {};
      formData.forEach((value, key) => {
        if (data[key]) {
          if (Array.isArray(data[key])) { data[key].push(value); }
          else { data[key] = [data[key], value]; }
        } else { data[key] = value; }
      });

      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Sending...';
      btn.disabled = true;

      const customerEmail = document.querySelector('[data-customer-email]');
      const contactBody = new URLSearchParams();
      contactBody.append('form_type', 'contact');
      contactBody.append('utf8', '\u2713');
      contactBody.append('contact[email]', customerEmail ? customerEmail.textContent : '');
      contactBody.append('contact[body]', type + ' from Account Dashboard:\n' + JSON.stringify(data, null, 2));
      contactBody.append('contact[tags]', 'account-dashboard,' + type.toLowerCase().replace(/ /g, '-'));

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: contactBody.toString()
      })
      .then(() => {
        btn.textContent = 'Saved!';
        btn.classList.add('account-dashboard__btn--success');
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('account-dashboard__btn--success');
        }, 3000);
      })
      .catch(() => {
        btn.textContent = 'Error - Try Again';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = originalText; }, 3000);
      });
    }

    initFeedbackModal() {
      const modal = document.getElementById('feedback-modal');
      const closeBtn = document.getElementById('feedback-modal-close');
      const feedbackForm = document.getElementById('feedback-form');
      const stars = document.querySelectorAll('.account-dashboard__star');
      const ratingInput = document.getElementById('feedback-rating');

      if (!modal) return;

      // Open modal from feedback triggers
      document.querySelectorAll('.account-dashboard__feedback-trigger').forEach(btn => {
        btn.addEventListener('click', () => {
          document.getElementById('feedback-order-id').value = btn.dataset.orderId;
          document.getElementById('feedback-order-name').value = btn.dataset.orderName;
          document.getElementById('feedback-order-label').textContent = 'Order ' + btn.dataset.orderName;
          ratingInput.value = '0';
          stars.forEach(s => s.classList.remove('account-dashboard__star--active'));
          feedbackForm.reset();
          modal.style.display = 'flex';
        });
      });

      // Close modal
      closeBtn.addEventListener('click', () => { modal.style.display = 'none'; });
      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.style.display = 'none';
      });

      // Star rating
      stars.forEach(star => {
        star.addEventListener('click', () => {
          const rating = star.dataset.rating;
          ratingInput.value = rating;
          stars.forEach(s => {
            s.classList.toggle('account-dashboard__star--active', s.dataset.rating <= rating);
          });
        });
      });

      // Submit feedback
      if (feedbackForm) {
        feedbackForm.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleFormSubmit(feedbackForm, 'Cleaning Feedback');
          setTimeout(() => { modal.style.display = 'none'; }, 2000);
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new AccountDashboard());
  } else {
    new AccountDashboard();
  }

  } catch(e) { console.error(e); }
})();
})();
